import React from 'react';

export const ActiveFolderIcon = ({
  width = 20,
  height = 20,
  color = '#000',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 7L11 5H6C4.89543 5 4 5.89543 4 7V17C4 18.1046 4.89543 19 6 19H18.0642C18.8314 19 19.5309 18.5611 19.8648 17.8704L22.3217 12.7878C22.8873 11.4681 21.9192 10 20.4834 10H20V9C20 7.89543 19.1046 7 18 7H13ZM18 10V9H12.1716L10.1716 7H6V13.1279L6.56129 11.8182C7.03403 10.7152 8.11864 10 9.31873 10H18ZM6.51648 17H18L20.4834 12H9.31873C8.9187 12 8.55716 12.2384 8.39958 12.6061L6.51648 17Z"
      fill={color}
    />
  </svg>
);
